import React from 'react'

import { useNonCompliancesCounter } from './_load/NonCompliancesCounterLoader'
import PercentGauge from '../../../../../packages/kiti-charts/components/charts/PercentGauge'

const NonCompliancesCounterChart = ({ widget }) => {
  const { height } = widget?.size || {}
  const data = useNonCompliancesCounter()
  const { invertPerspective } = widget?.data || {}
  let percent = data.nonCompliancesCount / data.totalCount
  if (invertPerspective) {
    percent = (data.totalCount - data.nonCompliancesCount) / data.totalCount
  }

  return <PercentGauge percent={percent} height={height * 0.5} invertColors={invertPerspective} />
}

export default NonCompliancesCounterChart
